import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'editorializer-home-container',
  templateUrl: './home-container.component.html',
  styleUrls: ['./home-container.component.scss']
})
export class HomeContainerComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
